// extracted by mini-css-extract-plugin
export var breadcrumbsWrapperStyle = "rsc_hb_page_header-module--breadcrumbsWrapperStyle--GKLiG";
export var wrapperStyle = "rsc_hb_page_header-module--wrapperStyle--26uYx";